import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Table from '../../../components/Table/Table.jsx'
import { getLocalPath } from '../../utility/config/configuration.js'
import { BehaviorSubject } from 'rxjs'
import { getSubscriptionDataByProductType } from '../../../components/FundDetails/Data/FundDetailsDataSource.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import { getSubscriptionsForUser } from '../../../components/EmailSubscriptionCenter/Data/SubscriptionCenterDataSource.js'
import { updateFundData } from '../../../components/EmailSubscriptionCenter/Landing/Helper/helper.js'
import SubscribeModalButton from '../../../components/EmailSubscriptionCenter/Modal/SubscribeModalButton.jsx'
import { updateFundSubscriptionBySubscriptionId } from '../../../components/EmailSubscriptionCenter/Modal/Data/subscriptions.js'
import { getLinkUrl } from '../../utility/index.js'
import { Link2 } from '../link/link.jsx'
const apiBasePath = `${getLocalPath()}/halapi/documents`
let ctiDataShare = null

export const CollectiveInvestmentTrustsTable = ({ parameters }) => {
  const [tableData, setTableData] = useState([])
  const [tableType, setTableType] = useState('cits')
  const [subscriptions, setSubscriptions] = useState([])
  const [subscriptionProfile, setSubscriptionProfile] = useState({})
  const [subscribeDocs, setSubscribeDocs] = useState({})
  if (!ctiDataShare) {
    ctiDataShare = new BehaviorSubject({})
  }

  const initializeSubscriptions = async () => {
    let ciTrustsSubscriptionList = await getSubscriptionDataByProductType(
      'collective-investment-trusts'
    )

    if (isLoggedIntoSubscriptionCenter()) {
      const _subscriptionProfile = await getSubscriptionsForUser()
      setSubscriptionProfile(_subscriptionProfile)
      if (ciTrustsSubscriptionList.length > 0) {
        ciTrustsSubscriptionList = updateFundData(
          ciTrustsSubscriptionList,
          _subscriptionProfile.value
        )
      }
      for (const subscription of ciTrustsSubscriptionList) {
        if (subscription.activeLiterature) {
          subscription.literature = subscription.activeLiterature
        }
      }
    }
    setSubscriptions(ciTrustsSubscriptionList)
  }

  const fetchTableData = async () => {
    let columnName = parameters?.scope.split('/')
    columnName = columnName[columnName?.length - 1]
    try {
      const response = await Axios.get(
        `${apiBasePath}?_scope=${parameters?.scope}&_limit=-1`
      )
      const data = response?.data?._embedded?.documents || []
      const result = data?.reduce(
        (p, n) => [
          ...p,
          {
            fundName: n?.title,
            docs: n?.content?.reduce(
              (j, i) => [
                ...j,
                {
                  fileName: i?.text,
                  url: `/binaries/${i?.Link[0]?._meta?.mirror?.path}`,
                },
              ],
              []
            ),
          },
        ],
        []
      )
      setTableData(result)
      setTableType(columnName)
    } catch (err) {
      console.log('CollectiveInvestmentTrustsTable', err)
    }
  }

  function updateSubscriptions(docId) {
    const _subscriptions = [...subscriptions]

    _subscriptions.map((fund) => {
      fund.literature.map((doc) => {
        if (doc.id === docId) {
          doc.selected = !doc.selected
        }
      })
    })

    setSubscriptions(_subscriptions)
  }

  const onSubscribeClicked = async ({ docId, ...rest }, subs) => {
    const docs = ctiDataShare?.value || {}
    const _newDocs = { ...docs }
    if (docs[docId]) {
      delete _newDocs[docId]
    } else {
      _newDocs[docId] = { docId, ...rest }
    }
    ctiDataShare.next(_newDocs)

    const hasCommentary = subs?.find((i) => i?.name?.includes('Commentary'))
    if (hasCommentary) {
      await updateFundSubscriptionBySubscriptionId(
        subscriptionProfile,
        hasCommentary?.docId,
        hasCommentary?.selected
      )
    }
  }

  const renderSubscribeModalButton = (fund, parentName) => {
    const sub = subscriptions?.find((sub) => sub.name === fund.fundName)

    const literature = (sub?.literature || []).map((doc) => ({
      ...doc,
      id: parentName + doc?.id,
      docId: doc?.id,
    }))
    const currentDoc = literature?.length > 0 && literature[0]
    const hasSubscribedDocs = subscribeDocs[currentDoc?.docId]
    const subs = literature.map((doc) => ({
      ...doc,
      selected: hasSubscribedDocs ? false : true,
    }))

    if (sub && currentDoc) {
      return (
        <SubscribeModalButton
          handleClicked={(doc) => onSubscribeClicked(doc, subs)}
          subscriptionProfile={subscriptionProfile}
          useUnlabeledButton={false}
          useInlineButton={false}
          useCheckBoxButton={true}
          currentDoc={
            hasSubscribedDocs
              ? { ...hasSubscribedDocs, id: currentDoc?.id }
              : currentDoc
          }
          subs={subs}
          updateSubscriptions={updateSubscriptions}
        />
      )
    }
  }

  const getColumns = () => {
    const tableHeads = {
      'stable-value-funds': [
        {},
        {
          name: 'storySheets',
          ariaLabel: 'Story Sheets',
          content: <div>Story Sheets</div>,
        },
        {
          name: 'factSheets',
          ariaLabel: 'Fact Sheets',
          content: <div>Fact Sheets</div>,
        },
        {
          name: 'emailUpdates',
          ariaLabel: 'Fact Sheet Email Updates',
          content: <div>Fact Sheet Email Updates</div>,
        },
      ],
      cits: [
        {},
        {
          name: 'factSheets',
          ariaLabel: 'Fact Sheets',
          content: <div>Fact Sheets</div>,
        },
        {
          name: 'commentaries',
          ariaLabel: 'Commentaries',
          content: <div>Commentaries</div>,
        },
        {
          name: 'emailUpdates',
          ariaLabel: 'Email Updates',
          content: <div>Email Updates</div>,
        },
      ],
    }
    const columns = [
      {
        name: 'fundName',
        ariaLabel: 'Fund Name',
        content: <div>Fund Name</div>,
        className: 'Table-header',
        button: {
          className: 'Table-headerNode u-padding2gu u-paddingRight4gu',
          sort: 'fundName',
          sortType: 'func',
          sortFunc: (fund) => fund.fundName,
        },
        cell: {
          hideRepeated: (fund) => fund.fundName,
          isRepeatedKey: true,
          content: (fund) => <div className="u-textBold">{fund.fundName}</div>,
        },
      },
      {
        className: `Table-header `,
        cell: {
          className: `u-textNoWrap `,
          content: (fund) => {
            const docs =
              tableType === 'stable-value-funds' ? fund?.docs[1] : fund?.docs[0]
            return !docs?.fileName ? (
              <></>
            ) : (
              <Link2
                url={getLinkUrl(docs)}
                text={`${docs?.fileName} (PDF)`}
                textClasses="u-textSecondary u-textSizeMsr"
              />
            )
          },
        },
      },
      {
        className: `Table-header `,
        cell: {
          className: `u-textNoWrap `,
          content: (fund) => {
            const docs =
              tableType !== 'stable-value-funds' ? fund?.docs[1] : fund?.docs[0]
            return !docs?.fileName ? (
              <></>
            ) : (
              <Link2
                url={getLinkUrl(docs)}
                text={`${docs?.fileName} (PDF)`}
                textClasses="u-textSecondary u-textSizeMsr"
              />
            )
          },
        },
      },
      {
        className: `Table-header `,
        cell: {
          className: `u-textNoWrap `,
          content: (fund) => renderSubscribeModalButton(fund, tableType),
        },
      },
    ]

    return columns?.map((i, idx) => ({
      ...i,
      ...(tableHeads[tableType][idx] || {}),
    }))
  }

  useEffect(() => {
    fetchTableData()
    initializeSubscriptions()
  }, [])

  useEffect(() => {
    const ctiDataShareInt = ctiDataShare.subscribe((docs) => {
      setSubscribeDocs(docs)
    })
    return () => ctiDataShareInt.unsubscribe()
  }, [])

  return (
    <div className="investment-products">
      <Table
        columns={getColumns()}
        rows={tableData}
        isRepeated={true}
        emptyMessage={<strong>No matching results found...</strong>}
      />
    </div>
  )
}
